<template>
    <div class="ml-v2" tabindex="-1">
        <img :src="merchantLogo" alt="" tabindex="-1" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters({
                merchantLogo: 'merchantLayout/getNewLogoUrl'
            })
        }
    };
</script>

<style lang="scss" scoped>
    .ml-v2 {
        img {
            height: auto;
			max-height: 64px;
    		max-width: 140px;
        }
    }
</style>
